import React from 'react';
import styles from './RealisationsHero.module.css'; // Crée un fichier CSS dédié pour ce Hero
 // Utilise ton composant Button existant

function RealisationsHero({ title, subtitle, backgroundImage, children }) {
  const heroStyle = {
    backgroundImage: `url(${backgroundImage})`,
  };

  return (
    <section className={styles.realisationsHero} style={heroStyle}>
      <div className={styles.heroContent}>
        <h1>{title}</h1>
        <p>{subtitle}</p>
        <div className={styles.heroButtons}>
          {children}
        </div>
      </div>
    </section>
  );
}

export default RealisationsHero;
